<!-- t(supportRequest) -->
<app-modal-header label="supportRequest" (closeDialog)="close()"> </app-modal-header>

<form id="supportRequestForm" class="modal-body" [formGroup]="form" (ngSubmit)="submit()" *transloco="let translate">
  <div class="controls-container">
    <mat-form-field appearance="fill">
      <mat-label>{{ translate("name") }}</mat-label>
      <input matInput formControlName="name" data-testid="support_request_name" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{ translate("emailAddress") }}</mat-label>
      <input matInput type="email" formControlName="email" data-testid="support_request_email" />
    </mat-form-field>
  </div>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>{{ translate("supportRequestHowCanWeHelp") }}</mat-label>
    <textarea
      matInput
      formControlName="message"
      data-testid="support_request_message"
      rows="5"
      [appMaxLength]="maxMessageLength">
    </textarea>
    <mat-hint align="end">{{ messageLength }}/{{ maxMessageLength }}</mat-hint>
  </mat-form-field>

  <div class="attachments-section">
    <div class="attachments-labels">
      <span class="attachments-title">{{ translate("supportRequestAttachments") }}</span>
      <span class="attachments-hint" [class.error]="isSizeExceeded()">{{ translate("supportRequestMaxSize") }}</span>
    </div>

    <div
      class="drop-zone"
      [class.drag-over]="isDragOver"
      [class.disabled]="isSubmitting()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="!isSubmitting() && openFilePicker()"
      role="button"
      [tabindex]="isSubmitting() ? -1 : 0"
      (keydown.enter)="!isSubmitting() && openFilePicker()"
      data-testid="support_request_drop_zone">
      <input
        #fileInput
        type="file"
        multiple
        class="visually-hidden"
        data-testid="support_request_file_input"
        (change)="onFileInputChange($event)" />

      <p class="drop-zone__primary">
        <svg class="drop-zone__icon">
          <use xlink:href="#attachment"></use>
        </svg>
        <span [innerHTML]="translate('supportRequestDragDrop')"></span>
      </p>
    </div>

    @if (attachments().length) {
      <div class="attachments-list">
        @for (attachment of attachments(); track attachment.task?.path ?? attachment.file?.path) {
          <app-support-attachment
            [attachment]="attachment"
            [disabled]="isSubmitting()"
            [hasError]="isSizeExceeded()"
            (remove)="removeAttachment(attachment)">
          </app-support-attachment>
        }
      </div>
    }
  </div>
</form>

<div class="modal-footer" *transloco="let translate">
  <button
    type="submit"
    form="supportRequestForm"
    data-testid="support_request_submit"
    class="btn btn-lg btn-active"
    [disabled]="isSubmitting()"
    [class.app-btn--in-action]="isSubmitting()">
    @if (isSubmitting()) {
      <span>{{ translate("supportRequestSending") }}</span>
      <mat-progress-spinner class="app-spinner-active" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
    } @else {
      <span>{{ translate("supportRequestSend") }}</span>
    }
  </button>
</div>
